import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { p2pProvidersApi } from 'api';
import { QueryKey } from 'enums';
import { P2PProviderTradeMethods } from 'types';

export function useP2PProvidersTradeMethods(enabled = true) {
  const queryResult = useQuery(
    [QueryKey.P2PProviders, 'trade-methods'],
    p2pProvidersApi.getTradeMethods,
    { enabled },
  );

  const tradeMethodsByProviderId = useMemo(
    (): Record<string, P2PProviderTradeMethods> =>
      keyBy(queryResult.data, 'id'),
    [queryResult.data],
  );

  return { tradeMethodsByProviderId, isLoading: queryResult.isLoading };
}
